import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';

export default function ProveedorAdmin() {
  const [proveedores, setProveedores] = useState([]);
  const [form, setForm] = useState({ nombre: '', ruc: '', direccion: '', telefono: '', correo: '' });

  const fetchProveedores = async () => {
    // const res = await axios.get('http://localhost:8080/api/proveedores');
    // setProveedores(res.data);
    
    // 🔧 Simulación de datos locales
    setProveedores([
      { id: 1, nombre: 'Proveedor A', ruc: '12345', direccion: 'Calle 1', telefono: '555-1234', correo: 'a@mail.com' },
      { id: 2, nombre: 'Proveedor B', ruc: '67890', direccion: 'Calle 2', telefono: '555-5678', correo: 'b@mail.com' }
    ]);
  };
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    // await axios.post('http://localhost:8080/api/proveedores', form);
    
    const newProveedor = { ...form, id: Date.now() };  // 🔧 Simulación local
    setProveedores([...proveedores, newProveedor]);
    
    setForm({ nombre: '', ruc: '', direccion: '', telefono: '', correo: '' });
    // fetchProveedores();  // ya no hace falta, porque lo actualizamos localmente
  };


  const handleDelete = async (id) => {
    // await axios.delete(`http://localhost:8080/api/proveedores/${id}`);
    
    setProveedores(proveedores.filter((p) => p.id !== id));  // 🔧 Simulación local
  };


  useEffect(() => {
    fetchProveedores();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Administrar Proveedores</h2>

      <div className="grid grid-cols-2 gap-4 mb-6">
        {['nombre', 'ruc', 'direccion', 'telefono', 'correo'].map((field) => (
          <input
            key={field}
            name={field}
            placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
            value={form[field]}
            onChange={handleChange}
            className="border p-2 rounded"
          />
        ))}
        <Button onClick={handleSubmit}>Agregar Proveedor</Button>
      </div>

      <table className="w-full table-auto border">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Nombre</th>
            <th className="border p-2">RUC</th>
            <th className="border p-2">Dirección</th>
            <th className="border p-2">Teléfono</th>
            <th className="border p-2">Correo</th>
            <th className="border p-2">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {proveedores.map((p) => (
            <tr key={p.id}>
              <td className="border p-2">{p.nombre}</td>
              <td className="border p-2">{p.ruc}</td>
              <td className="border p-2">{p.direccion}</td>
              <td className="border p-2">{p.telefono}</td>
              <td className="border p-2">{p.correo}</td>
              <td className="border p-2">
                <Button variant="outline" onClick={() => handleDelete(p.id)}>Eliminar</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
